module.exports = __webpack_public_path__ + "static/media/nowy-polski-pomidor.7155b0d6.png";